import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useState } from "react";
import { Button } from "reactstrap";
import {
  IScreenStatus,
  showScreenAsActivated,
  getScreenConnectionLabel,
} from "../../../app/models/screens";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { useLongPress } from "use-long-press";

interface IParams {
  screen: IScreenStatus;
}

const SelectedScreenButton: React.FC<IParams> = ({ screen }) => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { toggleScreenActivation, reloadUserScreens } = rootStore.screensStore;
  const [disabledClick, setDisabledClick] = useState(false);
  const {isMobileMediaQuery} = rootStore.responsiveStore

  const getIconColor = () => {
    if (showScreenAsActivated(screen)) return "text-success";
    else return theme!.toolbarIconColor;
  };

  const handleClick = async () => {
    await toggleScreenActivation(screen.id, false);
    await reloadUserScreens();
  };

  const handleLongClick = async () => {
    if (showScreenAsActivated(screen)) {
      await toggleScreenActivation(screen.id, showScreenAsActivated(screen));
      await reloadUserScreens();
    }
  };
  const callback = React.useCallback(() => {
    handleLongClick();
  }, [screen]);

  const bind = useLongPress(callback, {
    onStart: () => setDisabledClick(false),
    onCancel: () => setDisabledClick(true),
    threshold: 500,
  });

  return (
    <>
      <Button
        {...bind()}
        id="select"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 transparentButton",
          getIconColor(),
          isMobileMediaQuery ? "" : "toolbarButton"
        )}
        onClick={() => (disabledClick ? handleClick() : null)}
        color=""
        style={{ position: "relative" }}
      >
        <i className={classNames("fas fa-tv",isMobileMediaQuery ? "iconToolbarMobileButton" : "iconToolbarButton")}></i>
        <h6 className={classNames(" mb-0",isMobileMediaQuery ? "textToolbarMobileButton" : "textToolbarButton")}>
          {getScreenConnectionLabel(screen)}
        </h6>
      </Button>
    </>
  );
};

export default observer(SelectedScreenButton);
